import { Component } from '@angular/core';
import { LvrPaddingDirective } from '../../../shared/padding/padding.directive';

@Component({
	selector: 'lvr-simple-panel',
	templateUrl: './simple-panel.html',
	styleUrl: './simple-panel.scss',
	imports: [LvrPaddingDirective],
})
export class LvrSimplePanel {}
